import {css} from 'lit';
export const styles = css`:host {
  --font-weight: 700;
  --text-transform: uppercase;
  --day-font-size: var(--font-size-lg);
  --month-font-size: var(--font-size-sm);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 60px;
  background-color: var(--contrast-light);
  line-height: 1;
  border-radius: var(--border-radius);
}

.day {
  font-size: var(--day-font-size);
  font-weight: var(--font-weight);
}

.month {
  font-size: var(--month-font-size);
  text-transform: var(--text-transform);
  text-align: center;
  color: var(--dark-text-secondary);
}

:host(.with-divider) .month::before {
    content: '';
    display: block;
    height: 1px;
    width: 29px;
    margin: 4px;
    background: var(--gray-400);
  }

:host([layout='inline']) {
  flex-direction: row;
  width: 60px;
  height: 48px;
}

:host([layout='inline']) .month {
    margin-left: 4px;
  }

:host([layout='inline'].with-divider) .month {
    display: flex;
    align-items: center;
  }

:host([layout='inline'].with-divider) .month::before {
    height: 29px;
    width: 1px;
    margin: 0 4px 0 0;
  }
`;
export default styles;
